import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e453b5ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section ai-expertise" }
const _hoisted_2 = { class: "ai-expertise__intro" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ai-expertise__statement" }, " Der Anspruch ist nicht eine beeindruckende Demo, sondern ein System, dem Fachanwender vertrauen können: nachvollziehbar, integrierbar und fachlich belastbar. ", -1))
const _hoisted_4 = { class: "ai-expertise__grid" }

import SectionHeading from "@/components/SectionHeading.vue";
import { aiExpertiseItems } from "@/data/profile";

export default /*#__PURE__*/_defineComponent({
  __name: 'AiExpertiseSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SectionHeading, {
        eyebrow: "KI & RAG",
        title: "KI-Expertise für Wissenssysteme, die im Alltag tragen.",
        description: "RAG ist Architekturarbeit: Daten vorbereiten, Suche bewerten, Kontext steuern, Antworten belegen und fachliche Grenzen sichtbar halten."
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiExpertiseItems), (item) => {
        return (_openBlock(), _createElementBlock("article", {
          key: item.title
        }, [
          _createElementVNode("h3", null, _toDisplayString(item.title), 1),
          _createElementVNode("p", null, _toDisplayString(item.description), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.methods, (method) => {
              return (_openBlock(), _createElementBlock("li", { key: method }, _toDisplayString(method), 1))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})